
import { watchGetPromotionsSaga } from "./getPromotionsSaga";
import { watchGetVouchersSaga } from "./getVouchersSaga";

export default [watchGetPromotionsSaga(), watchGetVouchersSaga()];